export default {
    url: '/edit/:occurrenceId',
    template: `
        <div class="loader02" ng-if="!vm.occurrence"></div>
        <div class="heading01">
            <h2>{{ vm.occurrence.name }}</h2>
            <a class="btn discrete" ui-sref="authorized.courses.courses.edit.occurrence.list({ id: vm.course.id })">{{ 'course.Back to occurrences list' | translate }}</a>
        </div>
        <div class="alert alert-notify" ng-if="vm.OccurrenceService.isCancelled(vm.occurrence)">
            {{ 'course.cancelled occurrence notification' | translate }}
            <a ng-click="vm.OccurrenceService.copyFrom(vm.occurrence)">{{ 'course.cancelled occurrence copy link' | translate }}</a>
        </div>

        <ul class="tabs01">
            <li>
                <a ui-sref="authorized.courses.courses.edit.occurrence.edit.general({ id: vm.course.id, occurrenceId: vm.occurrence.id })"
                ng-class="{ active: vm.step==1 }">{{ 'course.General data' | translate }}</a>
            </li>
            <li>
                <a ui-sref="authorized.courses.courses.edit.occurrence.edit.employee({ id: vm.course.id, occurrenceId: vm.occurrence.id })"
                ng-class="{ active: vm.step==2 }">{{ 'course.Employees' | translate }}</a>
            </li>
            <li>
                <a ui-sref="authorized.courses.courses.edit.occurrence.edit.schedule({ id: vm.course.id, occurrenceId: vm.occurrence.id })"
                ng-class="{ active: vm.step==3 }">{{ 'course.Schedule' | translate }}</a>
            </li>
            <li>
                <a ui-sref="authorized.courses.courses.edit.occurrence.edit.files({ id: vm.course.id, occurrenceId: vm.occurrence.id })"
                ng-class="{ active: vm.step==4 }">{{ 'course.Files' | translate }}</a>
            </li>
        </ul>
        <ui-view></ui-view>
    `,
    resolve: {
        trainingTimesWithParticipants (OccurrenceResource, $stateParams) {
            return OccurrenceResource.getTrainingTimeParticipants({
                occurrenceId: $stateParams.occurrenceId,
                expand: 'courseOccurrenceTrainingTimeParticipants.trainingProgress'
            }).$promise;
        },
        occurrence (OccurrenceResource, $stateParams) {
            return OccurrenceResource.get(
                { id: $stateParams.occurrenceId, expand: 'courseOccurrenceParticipants,courseVersion,courseOccurrenceLanguages,courseOccurrenceManagers,files.addedBy,files.users,sites' }
            ).$promise;
        }
    },
    abstract: true,
    controller ($rootScope, $scope, lodash, course, rooms, occurrence, OccurrenceService, MomentService) {
        this.$scope = $scope;
        this.course = course;
        this.lodash = lodash;
        this.rooms = rooms;
        this.occurrence = occurrence;
        this.OccurrenceService = OccurrenceService;
        this.MomentService = MomentService;
        this.canManageOccurrences = !OccurrenceService.isReadonlyOccurrence(this.occurrence);

        if (this.occurrence.displayUntil) {
            this.occurrence.displayUntil = this.MomentService.formatTimeStamp(this.occurrence.displayUntil, 'YYYY-MM-DD HH:mm:ss', true);
        }

        const listener = $rootScope.$on('occurrence:reload', (event, reloadedOccurrence) => {
            this.occurrence = reloadedOccurrence;
            if (this.occurrence.displayUntil) {
                this.occurrence.displayUntil = this.MomentService.formatTimeStamp(this.occurrence.displayUntil, 'YYYY-MM-DD HH:mm:ss', true);
            }
            this.canManageOccurrences = !OccurrenceService.isReadonlyOccurrence(this.occurrence);
        });
        $scope.$on('$destroy', listener);
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/occurrence/edit/index.js